(function ($) {

    'use strict';

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    /*
     *      DOCUMENT READY
     */

    if ($("main .promo-block").length) {
        let topOfDiv = $("main .promo-block").offset().top; //gets offset of header
        let height = $("main .promo-block").outerHeight(); //gets height of header

        function checkClicked() {
            let clickCheck = getCookie("clickCheck");
            if (clickCheck !== "") {
                return clickCheck;
            } else {
                return false;
            }
        }

        // on scroll decide to show cookie
        $(window).scroll(function () {
            if (checkClicked() === false) {
                if ($(window).scrollTop() > (topOfDiv + height)) {
                    $("main .promo-block").addClass('fixed');
                } else {
                    $("main .promo-block").removeClass('fixed');
                }
            }
        });

        // on click close hide promo
        $(document).ready(function () {
            $(".promo-block .icon-clear").click(function () {
                let clickCheck = getCookie("clickCheck");
                if (clickCheck === '') {
                    setCookie('clickCheck', '7days', 7);
                } else if (clickCheck === '7days') {
                    setCookie('clickCheck', '30days', 30)
                }
                $(".promo-block").addClass('closed-promo');
            });
        })
    }

})(jQuery);
